import React from "react"
import { render } from "react-dom"

import { PortalHost } from "./PortalHost"

const portalHostId = "gds-portal-host"
let portalHostRendered = false

function _renderPortalHost() {
  let index = 0
  const getPortalHostId = () => `${portalHostId}${index}`
  // find an unused id
  // LS and ITA both have their own instance and host id
  while (document.getElementById(getPortalHostId())) {
    index++
  }
  const host = document.createElement("div")
  host.id = getPortalHostId()

  if (document.body) {
    document.body.appendChild(host)
  }

  render(<PortalHost />, host)
}

export function renderPortalHost() {
  // only render portal host for client side
  if (
    typeof window !== "undefined" &&
    typeof document !== "undefined" &&
    !portalHostRendered
  ) {
    _renderPortalHost()
    portalHostRendered = true
  }
}
